// extracted by mini-css-extract-plugin
module.exports = {"container":"SchoolMarkersContainer_container__TPPzG","mapContainer":"SchoolMarkersContainer_mapContainer__2kWxX"};